const getScrollTop = () => {
  let doc = document.documentElement
  return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
}

const getOffsetTop = (el) => {
  let rect = el.getBoundingClientRect()

  return rect.top + getScrollTop()
}

const getSupportsPassive = () => {
  let supportsPassive = false
  try {
    let opts = Object.defineProperty({}, 'passive', {
      get: function() {
        supportsPassive = true
      }
    })
    window.addEventListener('testPassive', null, opts)
    window.removeEventListener('testPassive', null, opts)
  } catch (e) {
  }

  return supportsPassive
}

function camelCaseToHyphen(camelCase) {
  return camelCase.replace( /([a-z])([A-Z])/g, '$1-$2' ).toLowerCase();
}

const getDataAttribute = (el, attribute) => {
  if (el.dataset) {
    return el.dataset[attribute]
  }

  return el.getAttribute(`data-${camelCaseToHyphen(attribute)}`)
}

const handleBrowserScrollRestoration = () => {
  // Make sure to always scroll to the top.
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual'
  }
  window.scrollTo(0, 0)
}


const getIsMobile = () => {
  return window.innerWidth <= 600
}

export {
  getScrollTop,
  getOffsetTop,
  getSupportsPassive,
  getDataAttribute,
  handleBrowserScrollRestoration,
  getIsMobile
}